import { Link } from 'react-router-dom';
import Seo from './Seo';
import './App.css';
import Footer from './Footer';
import Navbar from './Navbar';

// Firebase Hosting rewrites every unmatched path to index.html (required so
// direct loads of real client routes like /how-it-works work), so the server
// always answers 200 — there's no way to send a real HTTP 404 from a static
// SPA host. The noindex meta tag here is Google's documented workaround: it
// tells crawlers to drop the URL despite the 200, avoiding a soft-404 flag in
// Search Console. See https://developers.google.com/search/docs/crawling-indexing/javascript/fix-search-javascript#soft-404
function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | Baatcheet"
        description="This page doesn't exist on Baatcheet. Head back home to continue the baat."
        path="/404"
        noindex
      />
      <div className="bg" />
      <Navbar />
      <main className="shell" style={{ padding: '140px 28px 120px', textAlign: 'center' }}>
        <div className="kicker" style={{ justifyContent: 'center' }}>
          <span className="kicker-line" /> 404 · Not Found
        </div>
        <h1 className="h" style={{ marginTop: '8px' }}>
          Yeh <span className="stamp">rasta</span> kahin nahi jaata.
        </h1>
        <p className="lead" style={{ maxWidth: '480px', margin: '12px auto 28px' }}>
          The page you're looking for has moved, been renamed, or never existed.
          Let's get you back to the adda.
        </p>
        <div className="hero-cta" style={{ justifyContent: 'center' }}>
          <Link className="btn btn-cyan" to="/">← Back to Home</Link>
          <Link className="btn btn-ghost" to="/how-it-works">How it works</Link>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default NotFound;
